// @ts-nocheck
import useIsomorphicLayoutEffect from "@store/Framework/Common/Hooks/useIsomorphicLayoutEffect";
import { useScrollContext } from "@store/Framework/Components/ScrollContext/ScrollContext";
import { useCallback, useEffect, useState } from "react";

export default () => {
    const [scrollInit, setScrollInit] = useState(false);
    const { setScroll } = useScrollContext();

    const handleScroll = useCallback(() => {
        if (typeof window !== "undefined") {
            setScroll(document?.body?.scrollTop || document?.documentElement?.scrollTop);
        }
    }, [setScroll]);

    useIsomorphicLayoutEffect(() => {
        if (scrollInit) {
            handleScroll();
        }
    }, [scrollInit]);

    useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }
        setScrollInit(true);

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [setScrollInit]);
};
